module.exports = __webpack_public_path__ + "media/images/placeholders/spenden-box-dbf530037e5b70762ab2a76b39a1b693.jpg";